import { atomWithStorage } from "jotai/utils";
import { AuthResponse } from "../modules/Auth/types";

export const authAtom = atomWithStorage<AuthResponse | null>("auth", null);
